import React from "react";

import AuthHeader from "../../components/dashboard/authHeader";
import DisplayPosts from '../../components/dashboard/posts/';

function DashboardPosts() {

  return (
    <>
      <AuthHeader />
      <DisplayPosts />
    </>
  );
}

export default DashboardPosts;